The identifier for the posted `PositionProfile` to be closed.
